export const SCHEDULED_SECONDARY_OBJECTS = Object.freeze({
  BIKE: Object.freeze({
    kind: "static-attachment",
    model: "S3_D000_BIK02BKG.MT5",
  }),
});
